import { render, staticRenderFns } from "./SistemaQExamDetail.vue?vue&type=template&id=5f79b72c&scoped=true"
import script from "./SistemaQExamDetail.vue?vue&type=script&lang=js"
export * from "./SistemaQExamDetail.vue?vue&type=script&lang=js"
import style0 from "./SistemaQExamDetail.vue?vue&type=style&index=0&id=5f79b72c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f79b72c",
  null
  
)

export default component.exports